export default {"src":"/_next/static/media/plane-white.4ce7e2f9.svg","height":15,"width":17};